<!--
 * @Description: 手机号登录
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-05 19:28:38
 * @LastEditTime: 2019-07-26 16:12:09
 -->
<template>
  <div>
    <el-form ref="formData" :rules="form.rules" :model="form.data">
      <el-form-item prop="phone">
        <el-input v-model="form.data.phone" placeholder="请输入手机号" />
      </el-form-item>
      <!-- 手机验证码 -->
      <el-form-item prop="code">
        <el-row>
          <el-col :span="15">
            <el-input v-model="form.data.code" placeholder="请输入验证码" @keyup.enter.native="regFn" />
          </el-col>
          <el-col :push="1" :span="8">
            <el-button
              class="code-btn"
              :disabled="phoneCode.disabled"
              @click="getPhoneCode"
            >{{ phoneCode.sendCodeText }}{{ typeof phoneCode.sendCodeText === 'number' ? 's' : '' }}</el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getPhoneCodeLogin } from '@/api/common'
import { CountDown } from '@/utils/common'

export default {
  name: 'PhoneCodeLogin',
  data() {
    return {
      // 验证码相关
      phoneCode: {
        sendCodeText: '发送验证码',
        disabled: false,
        timer: null
      },
      form: {
        rules: {
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { validator: this.$validate('phone') }
          ],
          code: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
            // { validator: this.$validate('code') }
          ]
        },
        data: {

        }
      }
    }
  },
  computed: {
    codeid() {
      return 123
    }
  },
  beforeDestroy() {
    // 卸载组件前关闭定时器
    clearInterval(this.phoneCode.timer)
  },
  methods: {
    changeCode() {

    },
    // 关闭并清空定时器
    clearTimer(sendCodeText) {
      const phoneCode = this.phoneCode
      phoneCode.sendCodeText = sendCodeText
      clearInterval(phoneCode.timer)
      phoneCode.timer = null
      phoneCode.disabled = false
    },
    // 设置定时器
    setTimer() {
      const phoneCode = this.phoneCode
      phoneCode.disabled = true
      // 倒计时时间
      phoneCode.sendCodeText = CountDown
      phoneCode.timer = setInterval(() => {
        if (phoneCode.sendCodeText <= 1) {
          this.clearTimer('重新获取')
        } else {
          phoneCode.sendCodeText--
        }
      }, 1000)
    },
    // 获取手机验证码
    getPhoneCode() {
      this.$refs.formData.validateField('phone', (valid, str) => {
        if (!valid) {
          // 验证成功返回null
          this.setTimer()
          // { phone: this.form.data.username }
          getPhoneCodeLogin(this.form.data.phone).then(res => {
            console.log(res)
            this.$message({
              message: '验证码已发送',
              type: 'success'
            })
          //   // 由于方便测试每次从后台获取验证码自动填入表单
          //   // this.form.data.code = res.result
          }, () => {
            this.clearTimer('发送验证码')
          })
        }
      })
    },
    // 校验数据
    validateForm() {
      let flag = null
      this.$refs['formData'].validate(valid => {
        if (valid) {
          const formData = `?scope=server&mobile=SMS@${this.form.data.phone}&grant_type=mobile&code=${this.form.data.code}`
          flag = formData
        } else {
          flag = false
        }
      })
      return flag
    }
  }
}
</script>
